export const hasPerk = window.location.search.includes("perk_id") && window.location.search.split("=")[1];
export const isNotPerkOrImpactLevel = (donationFormData) => {
    var _a, _b, _c, _d;
    return (((_a = donationFormData.props) === null || _a === void 0 ? void 0 : _a.levels)
        && ((_b = donationFormData.props) === null || _b === void 0 ? void 0 : _b.levels.length) === 0)
        && (((_c = donationFormData.props) === null || _c === void 0 ? void 0 : _c.perk)
            && ((_d = donationFormData.props) === null || _d === void 0 ? void 0 : _d.perk) === null);
};
